module.exports = __webpack_public_path__ + "img/zs_11@2x.70695446.png";